import { AppRoutes } from '@bvi/dashboard/pages/routes';

import { withProviders } from './providers';

export const initApp = withProviders(() => <AppRoutes />);
